import React from 'react'
import Airtime from '../../Components/Products/airtime'

const MainAirtime = () => {
  return (
	 <Airtime />
  )
}

export default MainAirtime